<template>
  <div>
    <oil-form v-if='loading'
              :title='formTitle.toUpperCase()'
              :items='payment'
              :keys='keys'
              :createForm='!payment.Id || !this.id'
              :formCallback='formCallback'
    >
      <template v-slot:pen>
        {{ null }}
      </template>
      <template v-slot:PaymentAmount='{input}'>
        <v-text-field
            :items='payment'
            label='Сумма'
            v-model='tempAmount'
            :disabled='!input.isEdit'
            outlined
            dense
        >

        </v-text-field>
      </template>

      <template v-slot:Number='{input}'>
        <v-text-field
            v-model='payment.Number'
            label='Платежное поручение'
            :disabled='!input.isEdit'
            :readonly='checkComment ? true : false'
            outlined
            dense
        >
        </v-text-field>
      </template>
      <template v-slot:Checkbox='{input}'>
        <div style='position: relative'>
          <v-checkbox
              :disabled='!input.isEdit'
              style='position: absolute; top: -20px'
              label='Использовать комментарий'
              v-model='checkComment'
          >
          </v-checkbox>
        </div>
      </template>

      <template v-slot:Comment='{input}'>
        <v-text-field
            v-model='payment.Comment'
            label='Комментарий'
            :disabled='!input.isEdit'
            :readonly='checkComment ? false : true'
            outlined
            dense
        ></v-text-field>

      </template>

      <template v-slot:Buyer.Id='{rules,input}'>
        <v-autocomplete
            :items='buyers$'
            v-stream:keyup.native='searchCompany$'
            hide-no-data
            class='z-index'
            clearable
            :disabled='!input.isEdit'
            :rules='[...rules]'
            dense
            outlined
            @change='changeBuyer'
            hide-selected
            :value='payment.Buyer.CompanyName'
            item-text='CompanyName'
            label='Выбрать покупателя'
            return-object
        ></v-autocomplete>
      </template>
      <template v-slot:Contract.Id='{rules,input}'>
        <v-autocomplete
            :items='contracts$'
            v-stream:keyup.native='searchContract$'
            hide-no-data
            class='z-index'
            :rules='[...rules]'
            clearable
            :disabled='!input.isEdit'
            @change='changeContract'
            dense
            outlined
            :value='payment.Contract.Number'
            hide-selected
            item-text='Number'
            label='Выбрать договор'
            return-object
        ></v-autocomplete>
      </template>
      <template v-slot:Info='{input}'>
        <div class='container'>
          <h2>ИНФОРМАЦИЯ</h2>
        </div>
      </template>
    </oil-form>

  </div>
</template>

<script>

import { form } from '@/pages/setting/payment_create.json'
import { companiesService } from '@/services/CompaniesService'
import { num2str } from '@/utils/functions/MoneyFromString'
import { paymentService } from '@/services/PaymentService'
import { debounceTime, distinctUntilChanged, filter, pluck, switchMap } from 'rxjs/operators'
import { coreApi } from '@/services/core'
import { trimObject } from '~/utils'

export default {
  props: {
    id: {
      type: String
    }
  },
  data: () => ({
    tempAmount: '',
    loading: false,
    formTitle: 'СОЗДАТЬ ПЛАТЕЖ',
    keys: form.keys,
    outlined: true,
    dense: false,
    payment: {
      Buyer: {
        Id: '',
        TaxNo: '',
        Address: '',
        CompanyName: '',
        Dealer: '',
        AccountNumber: '',
        ContractNumbers: ''
      },
      PaymentDate: '',
      Contract: {
        Id: '',
        Number: '',
        SignedDate: ''
      },
      Number: '',
      Comment: '',
      AdditionalInformation: '',
      PaymentAmountInText: '',
      PaymentAmount: ''
    },
    companies: [],
    contracts: [],
    checkComment: false
  }),
  domStreams: ['searchCompany$', 'searchContract$'],
  subscriptions() {
    return {
      contracts$: this.searchContract$.pipe(
          pluck('event', 'target', 'value'),
          debounceTime(200),
          distinctUntilChanged(),
          switchMap(query => coreApi.get(`contract/search/number?pattern=${query}`)),
          pluck('data')
      ),
      buyers$: this.searchCompany$.pipe(
          pluck('event', 'target', 'value'),
          debounceTime(200),
          filter(value => value.length > 2),
          debounceTime(100),
          distinctUntilChanged(),
          switchMap(query => coreApi.get(`company/search/name?pattern=${query}`)),
          pluck('data')
      )
    }
  },
  components: {
    OilForm: () => import('@/components/helper/oil.form.vue')
  },
  async created() {
    const companies = await companiesService.getAll()
    this.buyers$ = companies.data

    if (this.id) {
      this.formTitle = 'ИНФО О ПЛАТЕЖИ'
      const payment = await paymentService.getById(this.id)
      const buyerId = payment.data?.Buyer?.Id
      this.payment = payment.data
      if (payment.data.Comment.length > 0) {
        this.checkComment = true
      }
      this.tempAmount = this.payment.PaymentAmount
      const buyer = await companiesService.getById(buyerId)
      this.payment.Buyer = buyer.data
      const contracts = await companiesService.getCompanyById({ companyId: buyerId })
      this.contracts$ = contracts.data
    }
    this.loading = true
  },
  computed: {
    storeType() {
      return this.id ? paymentService.update : paymentService.create
    },
    message() {
      return this.id ? 'платеж удачно изменен' : 'платеж удачно создан'
    }
  },
  methods: {
    async changeBuyer(buyer) {
      if (!buyer) return
      this.payment.Buyer = { ...buyer }
      const companyId = buyer?.Id
      const contracts = await companiesService.getCompanyById({ companyId: companyId })
      this.contracts = contracts.data
      this.contracts$ = contracts.data

    },
    changeContract(contract) {
      if (!contract) return
      this.payment.Contract = { ...contract }
      this.payment.Buyer = { ...contract.Buyer }
    },
    async formCallback(data, input, form, func) {
      input.isEdit = false
      const response = await this.storeType(data)
      const id = response.data?.Id

      if (!id) {
        input.isEdit = true
        return
      }
      this.payment.Id = id
      this.payment = response.data

      func(this.message)

      if (!this.id && id) {
        await this.$router.replace({
          path: `/payment/${id}`,
          replace: true
        })
      }
    }
  },
  watch: {
    tempAmount(numb) {
      this.payment.PaymentAmountInText = num2str(numb)
      this.tempAmount = numb.toString().replaceAll(' ', '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      this.payment.PaymentAmount = numb.toString().replaceAll(' ', '')
    },

    checkComment(val) {
      if (val) {
        this.payment.Number = ''
      }
    }
    // async 'payment.Buyer.Id'(id) {
    //   if (this.loading) {
    //     const buyer = this.companies.find(({Id}) => Id === id)
    //     this.payment.Buyer = {...buyer}
    //     const companyId = buyer?.Id
    //     const contracts = await companiesService.getCompanyById({companyId: companyId})
    //     this.contracts = contracts.data
    //     this.keys["Contract.Id"].attrs.items = contracts.data
    //   }
    //
    // },
    // 'payment.Contract.Id'(id) {
    //   if (this.loading) {
    //     const contract = this.contracts.find(({Id}) => Id === id)
    //     this.payment.Contract = {
    //       Id: contract?.Id,
    //       Number: contract?.Number,
    //       SignedDate: contract?.SignedDate,
    //     }
    //   }
    // },
  }
}
</script>


<style scoped>
.red-color {
  background-color: darkred;
}
</style>